import type { ReactNode } from 'react'
import { Logo } from '../components/Shell'
import { CrossCard } from '../ui/CrossCard'
import { ThemeToggle } from '../ui/ThemeToggle'

const POINTS = [
  { title: 'Up to 100 people', body: 'HD video that adapts to every connection, with a grid that pages as the room grows.' },
  { title: 'Invite in bulk', body: 'Paste emails or drop a CSV. Everyone gets a personal link and a calendar entry.' },
  { title: 'Yours to keep', body: 'Open source and self-hosted. Recordings and data stay on your server.' },
]

/** Split layout for sign-in and invitation screens: editorial hero left, form right. */
export function AuthLayout({
  eyebrow,
  title,
  lead,
  children,
}: {
  eyebrow: string
  title: ReactNode
  lead?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="grid min-h-full lg:grid-cols-[1.1fr_1fr]">
      <section className="grid-paper relative hidden flex-col justify-between border-r border-line py-10 pr-12 pl-[clamp(4rem,7vw,9rem)] lg:flex">
        <Logo />
        <div className="max-w-3xl">
          <p className="label-mono mb-5">Open-source video meetings</p>
          <h1 className="text-7xl font-bold xl:text-8xl">
            Meet everyone.
            <br />
            <span className="text-ink-3">Own everything.</span>
          </h1>
          <div className="mt-14 grid max-w-2xl gap-5 xl:grid-cols-3">
            {POINTS.map((p, i) => (
              <CrossCard key={p.title} index={String(i + 1).padStart(2, '0')} className="p-5">
                <h3 className="text-xl font-bold">{p.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink-2">{p.body}</p>
              </CrossCard>
            ))}
          </div>
        </div>
        <p className="label-mono">Self-hosted · LiveKit SFU · MIT</p>
      </section>

      <section className="flex flex-col px-5 py-6 sm:px-10">
        <div className="flex items-center justify-between lg:justify-end">
          <span className="lg:hidden">
            <Logo />
          </span>
          <ThemeToggle />
        </div>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12">
          <p className="label-mono mb-3">{eyebrow}</p>
          <h2 className="text-5xl font-bold">{title}</h2>
          {lead && <div className="mt-3 text-[16px] text-ink-2">{lead}</div>}
          {children}
        </div>
      </section>
    </div>
  )
}
